/**
 * @generated SignedSource<<dbae8240f676e6a1dfbda12abb7772fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppsSidebarDragDropProvider_OrganizationFragment$data = {
  readonly forYouDashboard: {
    readonly app: {
      readonly id: string;
    } | null;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "AppsSidebarDragDropProvider_OrganizationFragment";
};
export type AppsSidebarDragDropProvider_OrganizationFragment$key = {
  readonly " $data"?: AppsSidebarDragDropProvider_OrganizationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppsSidebarDragDropProvider_OrganizationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppsSidebarDragDropProvider_OrganizationFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Dashboard",
      "kind": "LinkedField",
      "name": "forYouDashboard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductApp",
          "kind": "LinkedField",
          "name": "app",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "fa4a8d13a9f63c67ca1f80e75471fab2";

export default node;
